import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from '../core/services/analytics.service';
import { GameService } from '../core/services/game.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';

@Component({
    selector: 'app-send-data',
    templateUrl: './send-data.component.html',
    styleUrls: ['./send-data.component.scss'],
    standalone: false
})
export class SendDataComponent implements OnInit {
  dataSent = false;
  userUid = '';

  constructor(
    private analyticsService: AnalyticsService,
    private gameService: GameService,
    private afAuth: AngularFireAuth,
  ) {}

  ngOnInit() {
    this.afAuth.user.subscribe((user) => {
      this.userUid = user.uid;
    });
  }

  sendData() {
    this.analyticsService.sendUserDataEmail().then();
  }

  skipDay() {
    this.gameService.skipDay();
  }

  downloadDataLocally() {
    this.analyticsService.downloadDataLocally();
  }
}
